// extracted by mini-css-extract-plugin
export default {"wrap":"MainArea_wrap__GnXha","wrapInner":"MainArea_wrapInner__pzkzw"};